const routes = [
    {
        path: "/promotional/processes",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "promotionalprocess_index"
        }
    }
];

export default routes;
